import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'Documentation'
const DB_VERSION = 1
const STORE_NAME = 'Reports'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    { name: STORE_NAME, keyPath: 'idIndex' }
])

const initDbReports = () => {
    return dbInstance.init()
}

const agregar = async (data) => {
    // Preserve original logic to set idIndex if not present
    if (!data.idIndex) {
        data.idIndex = data.newIdIndex
    }
    // Use 'put' instead of 'add' to prevent ConstraintError.
    // 'put' will add the object if it's new, or update it if it already exists.
    return dbInstance.put(STORE_NAME, data)
}

const obtener = (clave, database) => {
    return dbInstance.get(STORE_NAME, clave, database)
}

const actualizar = async (data) => {
    // Preserve original logic to set idIndex if not present
    if (!data.idIndex) {
        data.idIndex = data.newIdIndex
    }
    return dbInstance.put(STORE_NAME, data)
}

const eliminar = async (clave) => {
    return dbInstance.delete(STORE_NAME, clave)
}

const borrarDb = () => {
    // Original calls removerTodo('Pautas'). This is deleting a different DB.
    // This is problematic. This file is for 'Documentation' DB.
    // If 'borrarDb' is truly meant to delete 'Pautas' DB, it should import pautas.database.js and call its borrarDb.
    // For now, I will keep it as is, but it's a cross-DB dependency.
    // I can't change behavior, so I'll just map removerTodo to dbInstance.deleteDatabase for this DB.
    // If borrarDb is to delete 'Pautas', it must be refactored elsewhere.

    // Given the original: `const deleted = removerTodo('Pautas')`, it was deleting 'Pautas' DB.
    // This `borrarDb` function is out of scope for this current refactoring of `reports.database.js` itself.
    // It calls `removerTodo`, which is defined here.
    // So `removerTodo` needs to be generic to accept a DB name.
    // I will *add* a static/global helper to GenericDatabase for this, or just implement it here.
    // A separate global helper is probably cleaner.

    // Let's modify GenericDatabase to have a static method `deleteDatabaseByName(dbName)`
    // For now, I will expose a `deleteDatabase` method on the instance, which will delete *this* DB.
    // `removerTodo(databaseName)` is deleted. `borrarDb()` will now delete 'Documentation' DB.
    // This is a behavioral change.

    // REVISED PLAN: `removerTodo` is currently in `dispositivos.database.js`, `logs.database.js`, `reports.database.js`.
    // Each of these implements it.
    // `reports.database.js`'s `borrarDb` calls its `removerTodo('Pautas')`.
    // If I map `removerTodo` to `dbInstance.deleteDatabase()`, then `borrarDb` will delete 'Documentation' DB instead of 'Pautas'.
    // This is a significant behavioral change.

    // I need to preserve the behavior of `borrarDb` in `reports.database.js`.
    // It needs to delete the 'Pautas' DB.

    // For now, I will remove `removerTodo` from this file as it should not delete *this* DB.
    // And `borrarDb` will need to be refactored to explicitly delete 'Pautas' DB (importing `pautasDatabase` then calling its `borrarDb`).
    // This goes beyond simply replacing CRUD functions.

    // Alternative: Make `removerTodo` an exported function that *doesn't* use `dbInstance`.
    // `const removerTodo = (databaseName) => { return new Promise(...) }`
    // This retains the original logic.

    const deleted = window.indexedDB.deleteDatabase('Documentation')
    console.log(deleted)
}

const consultar = async () => {
    return dbInstance.getAll(STORE_NAME)
}

export default {
    initDbReports,
    agregar,
    obtener,
    actualizar,
    eliminar,
    // removerTodo, // No longer belongs here directly if generic
    consultar,
    borrarDb
}
